import './App.css';
import { Navbar, Header, Services, About, Footer } from './components/Index';
import React from 'react';



function App() {

  return (
    <React.Fragment>
      <Navbar />
      <Header />
      <Services />
      <About />
      <Footer />

    </React.Fragment>
  );
}

export default App;




